/**
 * "Vencida" is derived, never persisted: an open charge whose due day (in the
 * business timezone, São Paulo) is before today. Overdue charges keep their
 * Pix on screen — Asaas keeps the QR payable for a year after the due date
 * (see the "PIX exibível" rule in the payment-expiration business doc).
 */

const BUSINESS_TIME_ZONE = 'America/Sao_Paulo'

/** `YYYY-MM-DD` of the given instant in the business timezone. */
function businessDayKey(value: string | Date): string {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    return value.trim()
  }
  // en-CA formats as YYYY-MM-DD.
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(typeof value === 'string' ? new Date(value) : value)
}

/** True when the due day is before today (business timezone). */
export function isOverdue(dueAt: string | null | undefined, now: Date = new Date()): boolean {
  if (!dueAt) return false
  return businessDayKey(dueAt) < businessDayKey(now)
}

/** Due day as `dd/mm`, in the business timezone. */
export function formatDueDayShort(dueAt: string): string {
  const [, month, day] = businessDayKey(dueAt).split('-')
  return `${day}/${month}`
}

export const OVERDUE_PIX_NOTICE = (dueAt: string) =>
  `Venceu em ${formatDueDayShort(dueAt)}. Você ainda pode pagar com este Pix.`
